import React from "react";
import "../../styling/Dashboard.css";
import { ImDownload3 } from "react-icons/im";
import axios from "axios";


const InvoiceRightPanel = ({ brandingColours, invoiceDetail, event }) => {

  const totalAmount = invoiceDetail?.total || "0.00";
  const issueDate = invoiceDetail?.issuedDate
    ? new Date(invoiceDetail.issuedDate)
    : null;
  const formattedDate = issueDate
    ? issueDate.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "-";
  const formattedTime = issueDate
    ? issueDate.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })
    : "-";
  const billedToEmail = invoiceDetail?.billedTo?.email || "-";


  const handleDownload = async () => {
    try {
      const response = await axios.get(

        `${process.env.REACT_APP_API_URL}/event/invoice/${event._id}`

      );


      const url = response.data.downloadUrl;
      const link = document.createElement("a");
      link.href = url;
      link.download = "Invoice.pdf"; 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Failed to download invoice:", error);
      alert("Could not download the invoice. Please try again later.");
    }
  };


  return (
    <div style={{ width: "100%" }}>
      <div>
        <div className="right-panel-content" style={{ marginTop: "0px" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems:"flex-start",
            }}
            className="event-dues-box"
          >
            <div>
              <h4

                style={{
                  color: "#000000",
                  marginTop: "0px",
                  marginBottom: "5px",
                  fontWeight: "400",
                }}
              >
                Balance Due
              </h4>
              <h1
                style={{
                  color: "#000000",
                  marginBottom: "20px",
                  marginTop: "5px",
                }}
              >
                ${event?.expPaymentAmount}

              </h1>
            </div>
            <div
              style={{
                backgroundColor: "#E1FAE3",
                color: "#21A62C",
                padding: " 8px 10px",
                alignSelf: "initial",
                borderRadius:"5px",
                fontSize:"15px",
              }}
            >
              Paid
            </div>
          </div>
        </div>

        <div
          className="right-panel-content"
          style={{
            marginTop: "0px",
            borderTop: "hidden",
            borderBottom: "hidden",
          }}
        >
          <div className="right-panel-arrow-container">
            <span>
              <p
                style={{
                  color: "#625C73",
                  marginTop: "0px",
                  marginBottom: "5px",
                }}
              >
                Original Invoice Total
              </p>
            </span>
            <div
              style={{
                alignSelf: "flex-end",
                fontSize: "15px",
                marginRight: "30px",
                marginBottom: "5px",
                color: "#625C73",
              }}
            >
              ${totalAmount}
            </div>
          </div>
        </div>

        <div
          className="right-panel-content"
          style={{ marginTop: "0px", borderTop: "hidden", paddingTop: "0px" }}
        >
          <div className="right-panel-arrow-container">
            <span>
              <p
                style={{
                  color: "#625C73",
                  marginTop: "0px",
                  marginBottom: "5px",
                }}
              >
                Total amount received
              </p>
            </span>
            <div
              style={{
                alignSelf: "flex-end",
                fontSize: "15px",
                marginRight: "30px",
                marginBottom: "5px",
                color: "#625C73",
              }}
            >
              ${totalAmount}
            </div>
          </div>
        </div>

        <div
          className="right-panel-content"
          style={{ marginTop: "0px", borderTop: "hidden" }}
        >
          <h2
            style={{ color: "#000000", fontWeight: "400", marginTop: "0px" }}
          >
            Invoice Activity
          </h2>
          <h4
            style={{
              color: "#000000",
              fontWeight: "400",
              marginTop: "0px",
              marginBottom: "0px",
            }}
          >
            {formattedDate}
          </h4>
          <p
            style={{ fontSize: "12px", marginTop: "15px", color: "#625C73" }}
          >
            {formattedTime}
          </p>
          <p
            style={{ fontSize: "12px", marginTop: "0px", color: "#625C73" }}
          >
            {billedToEmail} made a ${totalAmount} payment
          </p>
        </div>
      </div>

      <div
        style={{ marginTop: "0px", width: "100%", paddingLeft: "0px" }}
        className="invoice-download-button-mobile"
      >
        <div style={{ marginTop: "15px", marginBottom: "30px", padding: "10px" }}>
          <button
            onClick={handleDownload}
            style={{
              marginTop: "0px",
              width: "100%",
              backgroundColor:  brandingColours?.primaryColor || "#2A1980",
              color: brandingColours?.secondaryColor || "#ffffff",
              fontSize: "15px",
              border: "hidden",
              cursor: "pointer",
              borderRadius:"5px",
              padding:"10px"
            }}
            className="events-button-hover-underline"
          >
            <span>
              <ImDownload3 />
            </span>{" "}
            Download Invoice
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvoiceRightPanel;
